import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import HeroDetail from "../../components/catalog/hero/HeroDetail/HeroDetail";
import SectionBreadcumb from "../../components/catalog/sections/SectionBreadcumb/SectionBreadcumb";
import SectionRecommended from "../../components/catalog/sections/SectionRecommended/SectionRecommended";
import Layout from "../../components/global/Layout";
import useSWR from "swr";

const fetcher = (url) => fetch(url).then((res) => res.json());

function useBookDetail(id, type) {
  const localStorageKey = "books"; // Key penyimpanan daftar buku

  // Gunakan useMemo untuk memastikan storedBooks tidak berubah di setiap render
  const storedBooks = useMemo(() => {
    const books = localStorage.getItem(localStorageKey);
    return books ? JSON.parse(books) : [];
  }, []);
  // Cari buku berdasarkan id dari storedBooks
  const foundBook = useMemo(
    () => storedBooks.find((book) => book.id === id),
    [storedBooks, id]
  );

  // Hanya fetch data jika buku tidak ditemukan di localStorage
  const { data, error, isValidating } = useSWR(
    foundBook
      ? null
      : `https://api.buku.kemendikdasmen.go.id/${type}/detail/${id}?code=GuruSejahtera2025`,
    fetcher,
    {
      refreshInterval: 18000000, // Re-fetch setiap 5 Jam
      dedupingInterval: 18000000, // Cegah fetching ulang dalam 5 Jam
      revalidateOnFocus: false, // Jangan revalidate saat window fokus kembali
      revalidateOnReconnect: false,
    }
  );

  // Gunakan data dari localStorage jika ada, jika tidak gunakan hasil fetch dari API
  const book = foundBook ?? data?.data ?? [];
  const loadingBook = isValidating;

  // Simpan hasil fetch ke localStorage setelah mendapatkan data dari API
  useEffect(() => {
    if (data?.results) {
      const updatedBooks = [
        ...storedBooks.filter((b) => b.id !== id),
        data.data,
      ]; // Update list tanpa duplikasi
      localStorage.setItem(localStorageKey, JSON.stringify(updatedBooks));
    }
  }, [data, id, storedBooks]);

  return { book, errorBook: error, loadingBook };
}

function useRecommendBooks(id, type) {
  // random number 1-8
  let randomNumber = Math.floor(Math.random() * 8) + 1;
  const { data, error, isValidating } = useSWR(
    `https://api.buku.kemendikdasmen.go.id/${type}/book?code=GuruSejahtera2025&page=${randomNumber}&per_page=4`,
    fetcher,
    {
      refreshInterval: 18000000, // Re-fetch setiap 5 Jam
      dedupingInterval: 18000000, // Cegah fetching ulang dalam 5 Jam
      revalidateOnFocus: false, // Jangan revalidate saat window fokus kembali
      revalidateOnReconnect: false,
    }
  );

  const recommendBooks = data?.data ?? [];
  const loadingRecommendBooks = isValidating ?? false;

  return { recommendBooks, errorRecommendBooks: error, loadingRecommendBooks };
}

const QRHandler = () => {
  const token = localStorage.getItem("user_token");
  const { id } = useParams();

  // Get query params type
  const searchParams = new URLSearchParams(window.location.search);
  const type = searchParams.get("type");

  const { recommendBooks, loadingRecommendBooks } = useRecommendBooks(id, type);
  const { book, loadingBook } = useBookDetail(id, type);

  return (
    <Layout>
      {book?.length !== 0 || loadingBook ? (
        <>
          <SectionBreadcumb
            category={"buku_sekolah_penggerak"}
            level={book?.level}
            title={book?.title}
            slug={book?.id}
          />
          <section className="container mb-5">
            <div className="card p-3 ">
              <h2>Scan HET</h2>
              <p>
                Halaman ini adalah hasil scan dari kover buku. Harap perhatikan
                URL pada browser, pastikan halaman ini bersumber dari domain{" "}
                <b>buku.kemendikdasmen.go.id</b>
              </p>
              <div>
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex">
                    <div style={{ width: '170px' }}><strong>Judul</strong></div>
                    <div style={{ width: '12px' }}>:</div>
                    <div className="flex-grow-1">{book?.title}</div>
                  </div>
                  <div className="d-flex">
                    <div style={{ width: '170px' }}><strong>Penerbit</strong></div>
                    <div style={{ width: '12px' }}>:</div>
                    <div className="flex-grow-1">{book?.publisher?.name}</div>
                  </div>
                  <div className="d-flex">
                    <div style={{ width: '170px' }}><strong>Mata Pelajaran</strong></div>
                    <div style={{ width: '12px' }}>:</div>
                    <div className="flex-grow-1">{book?.title}</div>
                  </div>
                  <div className="d-flex">
                    <div style={{ width: '170px' }}><strong>Kelas</strong></div>
                    <div style={{ width: '12px' }}>:</div>
                    <div className="flex-grow-1">{book?.school_level?.name}</div>
                  </div>
                  <div className="d-flex">
                    <div style={{ width: '170px' }}><strong>Harga</strong></div>
                    <div style={{ width: '12px' }}>:</div>
                    {book?.book_prices?.length > 0 ? (
                      <div className="flex-grow-1">
                        <ul className="ms-0 mb-0" style={{ paddingLeft: '18px' }}>
                          {book?.book_prices
                            ?.slice()
                            .sort((a, b) => {
                              const getSortKey = (zone) => {
                                if (!zone) return 999;
                                const match = String(zone).toUpperCase().match(/^(\d+)([A-Z])?$/);
                                if (!match) return Number(zone) || 999;
                                const num = Number(match[1]);
                                const letter = match[2] || '';
                                const add = letter === 'A' ? 0.1 : letter === 'B' ? 0.2 : 0;
                                return num + add;
                              };
                              return getSortKey(a?.zone) - getSortKey(b?.zone);
                            })
                            .map((price, index) => (
                              <li key={index}>
                                Zona {price?.zone}: Rp {Number(price?.price).toLocaleString("id-ID")}
                              </li>
                            ))}
                        </ul>
                      </div>
                    ) : (
                      <div className="flex-grow-1">
                        Rp {Number(book?.price).toLocaleString("id-ID")}
                      </div>
                    )}
                  </div>
                </div>

                <div className="mt-3">
                  {/* <div className="mb-3">
                    Harga ini tercantum pada SK Nomor <b>029/H/P/2025</b>.
                    Silakan melaporkan masalah jika terjadi perbedaaan harga
                    dengan menghubungi call center kami di nomor{" "}
                    <a href="#">+6285117487732</a>
                  </div> */}

                  <div>Belum tahu istilah Zona dalam HET? pelajari <a href="#" type="button" data-bs-toggle="modal" data-bs-target="#zonaModal">disini</a></div>
                </div>
              </div>
            </div>
          </section>
          <div className="modal fade" id="zonaModal" data-bs-backdrop="static">
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Keterangan Zona</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <table className="table table-striped">
                      <tbody>
                        <tr>
                            <td width={80}>Zona 1</td>
                            <td>Jawa Barat, Jawa Tengah, Jawa Timur, Daerah Istimewa Yogyakarta, DKI Jakarta, dan Banten</td>
                        </tr>
                        <tr>
                            <td>Zona 2</td>
                            <td>Bali, Nusa Tenggara Barat, Lampung (kecuali (i) Pesisir Barat), dan Sumatera Selatan.</td>
                        </tr>
                        <tr>
                            <td>Zona 3</td>
                            <td>Bengkulu, Jambi, Bangka Belitung,  Sumatera  Barat  (kecuali  (i)  Kepulauan  Mentawai  dan  (ii)  Solok Selatan), Riau (kecuali (i) Bengkalis, (ii) Kepulauan Meranti, (iii) , Sumatera Utara (kecuali (i) Nias, (ii) Nias Selatan, (iii) Nias Utara, (iv) Nias Barat), Sulawesi Selatan, Sulawesi Utara (kecuali (i) Kepulauan Sangihe, dan (ii) Kepulauan Talaud), Sulawesi Tengah (kecuali  (i)  Banggai  Kepulauan,  (ii)  Tojo  Uno- Uno, (iii) Sigi, dan (iv) Banggai Laut), Sulawesi Barat, Sulawesi Tenggara (Kecuali (i) Konawe,  (ii) Bombana, dan (iii) Konawe Kepulauan), dan Gorontalo.</td>
                        </tr>
                        <tr>
                            <td>Zona 4</td>
                            <td>Nanggroe Aceh Darussalam (kecuali (i) Aceh Besar dan (ii) Aceh Singkil), Kepulauan Riau (kecuali (i) Karimun, (ii)  Kepulauan Anambas, dan (iii)  Natuna), Nusa  Tenggara  Timur (kecuali (i) Sumba Barat, (ii) Sumba  Timur,  (iii)  Timor  Tengah  Selatan,  (iv)  Belu,  (v)  Alor,  (vi)  Lembata,  (vii)  Ende,  (viii) Manggarai,   (ix)   Rote   Ndao,   (x)   Manggarai   Barat,   (xi)   Sumba   Tengah,   (xii)   Sumba   Barat   Daya,   (xiii) Nagekeo, (xiv) Manggarai Timur, (xv) Sabu Raijua, dan (xvi) Malaka), Kalimantan  Barat  (kecuali  (i) Kapuas Hulu, (ii) Sanggau), Kalimantan Selatan, Kalimantan Tengah, Kalimantan Timur (kecuali (i) Mahakam Hulu, (ii) Berau), Kalimantan  Timur,  dan  Kalimantan  Utara  (kecuali  (i)  Nunukan,  (ii) Malinau.</td>
                        </tr>
                        <tr>
                            <td>Zona 5A</td>
                            <td>(1) Aceh  Besar,  (2)  Aceh  Singkil,  (3)  Nias,  (4)  Nias  Selatan,  (5)  Nias  Utara,  (6)  Nias  Barat,  (7)  Kep. Mentawai,  (8)  Solok  Selatan,  (9)  Pesisir  Barat,  (10)  Sumba  Barat,  (11)  Sumba  Timur,  (12)  Timor Tengah Selatan, (13) Belu, (14) Alor, (15) Lembata, (16) Ende, (17) Manggarai, (18) Rote Ndao, (19) Manggarai Barat, (20) Sumba  Tengah,  (21) Sumba Barat Daya, (22)  Nagekeo, (23) Manggarai Timur, (24) Sabu Raijua, (25) Malaka, (26) Banggai  Kepulauan,  (27)  Tujo  Una-Una,  (28)  Sigi,  (29)  Banggai Laut, (30) Konawe, (31) Bombana, (32) Konawe Kepulauan, (33) Bengkalis, (34) Kepulauan Meranti, (35) Karimun, (36) Kepulauan Anambas, (37) Natuna, (38) Kapuas Hulu, (39) Mahakam Hulu, (40) Sanggau, (41) Nunukan, (42) Malinau,  (43)  Berau,  (44)  Kepulauan Sangihe, dan (45) Kepulauan Talaud.</td>
                        </tr>
                        <tr>
                            <td>Zona 5B</td>
                            <td>Papua, Papua Barat, Maluku, dan Maluku Utara</td>
                        </tr>
                      </tbody>
                    </table>
                  <div>
                    Isi keterangan Zona akan ditambahkan di sini.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="text-center my-5">
          <img
            width="60"
            src="/assets/image/catalog/not-found.png"
            className="img-fluid"
            alt="Not found"
          />
          <div className="text-center mt-2">
            Buku tidak ditemukan / dalam revisi
          </div>
        </div>
      )}
    </Layout>
  );
};

export default QRHandler;
